import { createSlice } from "@reduxjs/toolkit";
import { Route } from "../../routes/store/slice";
import { User } from "../../users/store/slice";

export type UserFilters = {
  routes: Route[];
  customers: User[];
  departure_dates: string[];
  arrival_dates: string[];
};

type InitialState = {
  data: UserFilters | null;
  isLoading: boolean;
};

const initialState: InitialState = {
  data: null,
  isLoading: false,
};

const userFiltersSlice = createSlice({
  name: "userFiltersSlice",
  initialState,
  reducers: {
    fetchData: (state) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default userFiltersSlice;
